import { Injectable } from '@angular/core';
import { ConvertHelper } from 'app/shared/helpers/convert-helper';
import { BehaviorSubject, Observable } from 'rxjs';
import { LaboratoryHttpHeaderModel } from './laboratory-http-header-model';

@Injectable({
  providedIn: 'root',
})
export class LaboratoryHttpHeaderService {
  private _laboratoryHttpHeader: LaboratoryHttpHeaderModel;
  private _onHttpHeaderChanged: BehaviorSubject<LaboratoryHttpHeaderModel | null> | null;
  private _previousLastNonFreeSubscriptionProductType: string | null;
  private _previousLastSubscriptionEndDate: string | null;
  private _previousStorageCapacityLimit: number | null | undefined;
  private _previousStorageUsage: number | null | undefined;
  private _previousSubscriptionEndDate: string | null;
  private _previousSuspendedFlag: boolean | undefined;

  public constructor() {
    this._onHttpHeaderChanged = new BehaviorSubject<LaboratoryHttpHeaderModel | null>(null);
  }

  public get onHttpHeaderChanged(): Observable<LaboratoryHttpHeaderModel | null> {
    return this._onHttpHeaderChanged!.asObservable();
  }

  public getHttpHeader(): LaboratoryHttpHeaderModel {
    return this._laboratoryHttpHeader;
  }

  public setHttpHeaderInfo(
    subscriptionEndDate: string | null,
    lastSubscriptionEndDate: string | null,
    lastNonFreeSubscriptionProductType: string | null,
    storageCapacityLimit: string | null,
    storageUsage: string | null,
    suspendedFlag: string | null,
  ): void {
    const storageCapacityLimitNumber = ConvertHelper.toNumber(storageCapacityLimit);
    const storageUsageNumber = ConvertHelper.toNumber(storageUsage);
    const suspendedFlagBoolean = ConvertHelper.toBoolean(suspendedFlag);
    const hasChangedFlag =
      this._previousSubscriptionEndDate !== subscriptionEndDate ||
      this._previousLastSubscriptionEndDate !== lastSubscriptionEndDate ||
      this._previousLastNonFreeSubscriptionProductType !== lastNonFreeSubscriptionProductType ||
      this._previousStorageCapacityLimit !== storageCapacityLimitNumber ||
      this._previousStorageUsage !== storageUsageNumber ||
      this._previousSuspendedFlag !== suspendedFlagBoolean;

    if (!this._laboratoryHttpHeader || hasChangedFlag) {
      this._laboratoryHttpHeader = new LaboratoryHttpHeaderModel(
        subscriptionEndDate,
        lastSubscriptionEndDate,
        lastNonFreeSubscriptionProductType,
        storageCapacityLimitNumber,
        storageUsageNumber,
        suspendedFlagBoolean,
      );

      this._previousSubscriptionEndDate = subscriptionEndDate;
      this._previousLastSubscriptionEndDate = lastSubscriptionEndDate;
      this._previousLastNonFreeSubscriptionProductType = lastNonFreeSubscriptionProductType;
      this._previousStorageCapacityLimit = storageCapacityLimitNumber;
      this._previousStorageUsage = storageUsageNumber;
      this._previousSuspendedFlag = suspendedFlagBoolean;

      this._onHttpHeaderChanged!.next(this._laboratoryHttpHeader);
    }
  }
}
